/**
 * @param element The HTML element to be verified.
 * @param verifyHeight Verify offset and scroll heights, this is needed when we truncate the content using line clamp.
 */
export function isElementTruncated(element: HTMLElement, verifyHeight = false): boolean {
  return element.offsetWidth < element.scrollWidth || (verifyHeight && element.offsetHeight < element.scrollHeight)
}
